export const parseJSON = json => {
    try {
        return JSON.parse(json);
    }
    catch (_a) {
        return {};
    }
};
//# sourceMappingURL=utils.js.map